<template>
  <div v-if="loading" class="flex h-screen w-full flex-col items-center justify-center gap-y-2">
    <Loader2 class="mr-2 h-4 w-4 animate-spin" :size="48" />
    <span>{{ t('preview.loadingPreview') }}</span>
  </div>
  <pre v-else-if="error">{{ error }}</pre>
  <div v-else class="container my-4 grid gap-y-12 lg:gap-y-24">
    <Post :preview="true" :post="post" :clickable="false" :fullscreen_allowed="false" />
  </div>
</template>

<script setup lang="ts">
import Post from '@modules/Post/Post.vue';
import { ref, reactive } from 'vue';
import type { PostInterface } from '@modules/Post/post.interface';
import { useArtistStore } from '@stores/artist.store';
import { storeToRefs } from 'pinia';
import { Loader2 } from 'lucide-vue-next';
import { onMounted } from 'vue';
import { useEventListener } from '@vueuse/core';
import moment from 'moment';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const artistStore = useArtistStore();
const { id: artistId } = storeToRefs(artistStore);
const loading = ref(true);
const error = ref<string | null>(null);

const now = moment().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');

const post = reactive<PostInterface>({
  id: 'preview-1',
  artist_id: artistId.value,
  created_at: now,
  scheduled_at: '',
  image_url: '',
  image_urls: [],
  title: '',
  type: 'image',
  meta_data: {},
  pinned: false,
  status: 'live',
  text: '',
  commentCount: 0,
});

useEventListener(window, 'message', (event: MessageEvent) => {
  // Validate the origin
  if (event.origin !== import.meta.env.VITE_MANAGER_ORIGIN) {
    error.value = t('preview.couldNotLoadPreview');
    return;
  }
  const { type, payload } = event.data;

  if (type === 'CONTENT_UPDATE') {
    // console.log('Received update:', payload);
    try {
      const parsedPayload = JSON.parse(payload);
      post.title = parsedPayload.title || '';
      post.text = parsedPayload.text || '';
      post.image_url = parsedPayload.imageUrl || '';
      post.image_urls = parsedPayload.imageUrls || [];
      post.type = parsedPayload.type || 'image';
      post.status = parsedPayload.status || 'live';
      post.pinned = parsedPayload.pinned || false;
      post.scheduled_at = parsedPayload.scheduledAt || '';
      post.created_at = parsedPayload.createdAt || now;
      // post.commentCount = parsedPayload.commentCount || 0;
      // post.meta_data = parsedPayload.metaData || {};
    } catch (err: unknown) {
      console.error('Error updating post:', err);
      error.value = t('preview.errorUpdatingPreview');
    }
    // console.log('Updated Post to:', post);
  }
});

onMounted(() => {
  setTimeout(() => {
    loading.value = false;
  }, 1000);
});
</script>
